<template>
    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :searchs="searchs" :form-fields="formFields" :permission="permission"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "Ip",
        components: {CommonTable},
        data(){
            return {
                searchs:[{
                    name: 'adminId',
                    placeholder: '管理员',
                    type: 'select',
                    selectUrl: '/adminInfo/getAll',
                    selectData: [],
                }, {
                    name: 'ip',
                    placeholder: 'IP地址',
                    type: 'input'
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission:{
                    add: 'adminIp:add',
                    update: 'adminIp:update',
                    delete: 'adminIp:delete',
                    deleteBatch: 'adminIp:deleteBatch'
                },
                url: {
                    get: '/adminIp/listByCondition',
                    add: '/adminIp/add',
                    update: '/adminIp/update',
                    delete: '/adminIp/delete/',
                    delete_batch: '/adminIp/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                },{
                    field: 'adminId',
                    label: '管理员',
                    selectUrl: '/adminInfo/getAll',
                    selectData: [],
                    show: {
                        type:'select'
                    },
                    width: '',
                }, {
                    field: 'ip',
                    label: 'IP地址',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加管理员IP',
                    updateTitle: '修改管理员IP',
                    model: [{
                        field: 'ip',
                        label: 'IP地址：',
                        type: 'input',
                        placeholder: 'ip',
                        rules:[{message: '请输入IP地址', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'adminId',
                        label: '管理员：',
                        type: 'select',
                        placeholder: '请选择',
                        rules:[{required: true, message: '请选择管理员', trigger: 'blur'}],
                        selectUrl: '/adminInfo/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
